import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ToastContainer } from "react-toastify";

import { CssBaseline, ThemeProvider as MuiThemeProvider } from "@mui/material";

import legacyTheme from "./styles/theme";
import theme from "./styles";
import { AuthProvider } from "./hooks/useAuth";
import { TranslateProvider } from "./hooks/useTranslate";

import Routes from "./routes";
import React from "react";
import DialogProvider from "./hooks/useDialog";
import ModalProvider from "./hooks/useModal";
import { SnackbarProvider } from "notistack";
import GlobalStyles from "./styles/global";

const App: React.FC = () => {
  return (
    <>
      <CssBaseline />
      <MuiThemeProvider theme={theme}>
        <ThemeProvider theme={legacyTheme}>
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{ horizontal: "right", vertical: "top" }}
          >
            <TranslateProvider>
              <DialogProvider>
                <ModalProvider>
                  <BrowserRouter>
                    <AuthProvider>
                      <GlobalStyles />
                      <ToastContainer autoClose={5000} />
                      <Routes />
                    </AuthProvider>
                  </BrowserRouter>
                </ModalProvider>
              </DialogProvider>
            </TranslateProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </>
  );
};

export default App;
